export default __webpack_public_path__ + "2318986f22dd3372cf707de3f8817384.png";